// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"2fdb002a","202":"436e4021","418":"960de6dd","747":"5a4be404","815":"4e507046"}[chunkId] + ".chunk.js";
};